import { Star } from "lucide-react";

import { SECTION_TYPES } from "@/lib/constants/sections";

import type { ServiceSection } from "@/types/sections";

const testimonialsSection: ServiceSection = {
  type: SECTION_TYPES.TESTIMONIALS,
  content: {
    header: "Our clients love us",
    subheader: "Here's some of what they had to say",
    variantNumber: 0,
  },
  meta: {
    displayName: "Testimonials",
    displayDescription: "Give your customers a reason to trust you.",
    displayIcon: Star,
    variantsCount: 4,
  },
};

export default testimonialsSection;
